import React, { FC } from 'react';
import { Checkbox, CheckboxProps, Error } from '@trip-ux/components';
import { FieldRenderProps } from 'react-final-form';
import { isEmpty } from 'lodash';

export const GenericCheckbox: FC<FieldRenderProps<boolean> & CheckboxProps> = ({
  input,
  meta,
  validateOnBlur, // when <Form> validates on blur, need to add this to force validation onChange for checkbox only
  showError,
  children,
  inputOnChange,
  id,
  ...checkboxProps
}) => {
  const errors = (meta.modified && !input.value) || (meta.submitFailed && validateOnBlur) ? meta.error : undefined;
  const hasError = !isEmpty(errors);
  return (
    <div>
      <Checkbox
        name={input.name}
        id={id}
        {...checkboxProps}
        onChange={val => {
          input.onChange(val);
          validateOnBlur && input.onBlur();
          inputOnChange && inputOnChange(val);
        }}
        checked={input.value}
        hasError={hasError}>
        {children}
      </Checkbox>
      {hasError && <Error errors={errors} callout={false} id={`${id}-described`} />}
    </div>
  );
};
GenericCheckbox.displayName = 'GenericCheckBox';
